import store from '@/store'

export default (to, from, next) => {
  if (store.getters.authToken) {
    next()
  } else {
    next('/auth')
  }
}



// WEBPACK FOOTER //
// ./src/middlewares/Auth.js